import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { FaInfoCircle } from 'react-icons/fa';

import '../stylesheets/components/Charts.css';
import PropTypes from 'prop-types';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function DoughnutChart({ metricsData }) {
  const data = {
    labels: ['Guided Route', 'Self-Reflective', 'No Prep'],
    datasets: [
      {
        label: 'People',
        data: metricsData !== null ? [
          metricsData.conversationPrepPctValues.guidedRoutePct >= 0 ? metricsData.conversationPrepPctValues.guidedRoutePct : 0,
          metricsData.conversationPrepPctValues.selfGuidedRoutePct >= 0 ? metricsData.conversationPrepPctValues.selfGuidedRoutePct : 0,
          metricsData.conversationPrepPctValues.noPrepPct >= 0 ? metricsData.conversationPrepPctValues.noPrepPct : 0
        ] : [0, 0, 0],
        backgroundColor: ["#F765A3", '#A155B9', '#165BAA'],
        borderWidth: 0 // Remove gaps between segments
      },
    ],
  };

  const options = {
    plugins: {
      datalabels: {
        display: true,
        color: 'white',
        font: {
          size: 12,
          weight: 300,
          family: 'Roboto'
        },
        formatter: function (value, context) {
          return value;
        },
        anchor: 'center',
        align: 'center',
        textStrokeColor: 'rgba(0,0,0,0.3)',
        textStrokeWidth: 1,
      },
      legend: {
        display: false // Disable built-in legend
      }
    },
    maintainAspectRatio: false,
  };

  const legendItems = [
    { label: 'Guided Route', color: '#F765A3' },
    { label: 'Self-Reflective', color: '#A155B9' },
    { label: 'No Prep', color: '#165BAA' }
  ];

  return (
    <div className="chart-card-container">
      <div className="chart-card chart-card--vertical">
        <div className="chart-card__header">
          <div className="chart-card__title-row">
            <span className="chart-card__title">Type of Preparation Completed %</span>
            <span className="chart-card__icon"><FaInfoCircle size={16} color="#A0A0A0" title="Info" /></span>
          </div>
          <div className="chart-card__subtitle"></div>
        </div>
        <hr className="chart-card__divider" />        <div className="chart-card__body chart-card__body--horizontal">
          <div className="chart-card__doughnut-wrap">
            <Doughnut data={data} options={options} plugins={[ChartDataLabels]} />
          </div>
          <div className="chart-card__legend-area">
            {legendItems.map(item => (
              <div className="custom-legend-item" key={item.label}>
                <span className="custom-legend-color" style={{ background: item.color }}></span>
                <span className="custom-legend-label">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
  
}

DoughnutChart.propTypes = {
  metricsData: PropTypes.shape({
    conversationPrepPctValues: PropTypes.shape({
      guidedRoutePct: PropTypes.number,
      selfGuidedRoutePct: PropTypes.number,
      noPrepPct: PropTypes.number,
    }),
  })
};